function initCollectionTabs() {
  var tabs = document.querySelectorAll(
    ".collection-tabs .collection-tabs__tab"
  );
  var contents = document.querySelectorAll(
    ".collection-tabs .collection-tabs__panel"
  );
  tabs.forEach(function (tab) {
    tab.addEventListener("click", function () {
      tabs.forEach(function (t) {
        t.classList.remove("active");
      });
      tab.classList.add("active");
      contents.forEach(function (c) {
        c.classList.remove("active");
      });
      var target = document.getElementById(tab.dataset.tab);
      if (target) target.classList.add("active");
    });
  });
}

document.addEventListener("DOMContentLoaded", initCollectionTabs);
document.addEventListener("shopify:section:load", initCollectionTabs);
